import * as React from 'react';

const useOutsideClick = (
  ref: React.RefObject<HTMLElement>,
  onOutsideClick: (event: MouseEvent) => void
) => {
  React.useEffect(() => {
    const handleMouseEvent = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      if (!ref.current || (target && ref.current.contains(target))) {
        return;
      }

      onOutsideClick(event);
    };

    document.addEventListener('mousedown', handleMouseEvent);
    document.addEventListener('touchstart', handleMouseEvent);

    return () => {
      document.removeEventListener('mousedown', handleMouseEvent);
      document.removeEventListener('touchstart', handleMouseEvent);
    };
  }, [ref, onOutsideClick]);
};

export default useOutsideClick;



// WEBPACK FOOTER //
// ./src/hooks/useOutsideClick.tsx